import { render, staticRenderFns } from "./mySpan.vue?vue&type=template&id=44f2d8d9&"
import script from "./mySpan.vue?vue&type=script&lang=js&"
export * from "./mySpan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports